import SadFace from './SadFace';
import Tick from './Tick';

export { SadFace, Tick };



// WEBPACK FOOTER //
// ./packages/marvel-ui-button/icons/index.js